import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import Button from "components/common_components/Button";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function FormDialog({
    open,
    title,
    children,
    formId,
    primaryButtonText,
    secondaryButtonText,
    onClose,
    onSecondaryClick,
    readOnly,
    inFullScreen,
    isSubmitting,
    ...rest
}) {
    const theme = useTheme();
    const isBreakpointPassed = useMediaQuery(theme.breakpoints.down("sm"));
    const fullScreen = typeof inFullScreen === "undefined" ? isBreakpointPassed : inFullScreen;

    return (
        <div>
            <Dialog
                open={open}
                fullScreen={fullScreen}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                {...rest}
            >
                <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
                <DialogContent>{children}</DialogContent>
                <DialogActions>
                    <Button primary outline onClick={onClose}>
                        {secondaryButtonText}
                    </Button>
                    {!readOnly && (
                        <Button primary type="submit" formId={formId} loading={isSubmitting}>
                            {primaryButtonText}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
}

FormDialog.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.node,
    children: PropTypes.node,
    primaryButtonText: PropTypes.string,
    secondaryButtonText: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onSecondaryClick: PropTypes.func,
    readOnly: PropTypes.bool,
    inFullScreen: PropTypes.bool,
    isSubmitting: PropTypes.bool,
};

FormDialog.defaultProps = {
    open: false,
    title: "",
    children: "",
    formId: "",
    primaryButtonText: "Save",
    secondaryButtonText: "Cancel",
    onSecondaryClick: () => {},
    readOnly: false,
    inFullScreen: undefined,
    isSubmitting: false,
};

export default FormDialog;
